/* eslint-disable max-len */
const fee = require('./fee.json');
const feeConfiguration = require('./fee-configuration.json');

/**
 * Fee Schema.
 * No additional properties are allowed.
 * @typedef {Object} SalesVxAccountingFee
 * @property {number} amount - The fee amount. Required.
 * @property {string} type - The fee type. Required.
 * @property {string} paymentType - The fee payment type. Required. *
 * @property {IdentityDocument} [identities] - The identities. Optional.
 * @property {Number} [__v] the version should this be an update
 */

/**
 * Sales VX Accounting Fee Config Schema.
 * Additional properties are allowed.
 *
 * @typedef {Object} SalesVxAccountingConfiguration
 *
 * @property {number} amount - The fee amount. Required.
 * @property {string} type - The fee type (e.g. application, origination). Required.
 * @property {string} paymentType - The payment type for the fee. Required.
 * @property {string|null} [descriptionType] - Optional description type.
 * @property {IdentityDocument} [identities] - Optional identities associated with the fee (application or lead).
 * @property {string} [purpose] - Optional loan purpose.
 * @property {number} [loanAmount] - Optional loan amount
 * @property {number|null} [__v] - Optional version field when updating an existing fee.
 * @property {*} [additionalProperties] - Any additional properties are allowed for forward compatibility.
 */


/**
 * Sales related validation schemas for accounting
 * @module schemas/sales/accounting
 * @property {SalesVxAccountingFee} fee
 * @property {SalesVxAccountingConfiguration} feeConfiguration
 */
module.exports = {
  fee,
  feeConfiguration,
};
